module.exports = __webpack_public_path__ + "img/moonhill.953cfc5c.png";